// A byte count in the units a browser reports quotas in.
//
// It lives in `assets/` because §6.5 makes that the one place two built-ins may share code, and
// Settings' storage readout and the Recycle Bin's usage line must not disagree about what a
// megabyte is.
const UNITS = ['B', 'kB', 'MB', 'GB', 'TB'] as const;

/** Decimal units, because that is what `navigator.storage.estimate()` reports in. */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const power = Math.min(UNITS.length - 1, Math.floor(Math.log10(bytes) / 3));
  const value = bytes / 1000 ** power;
  const digits = power === 0 || value >= 100 ? 0 : 1;
  return `${value.toFixed(digits)} ${UNITS[power] ?? 'B'}`;
}
